var _rect, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 56",
    width: 220,
    height: 56,
    role: "img",
    "aria-label": "AURA Sa\\xFAde",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#20a490"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 34 L16 34 L19 24 L24 40 L28 30 L31 34 L34 34",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 30,
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#1f2d3d"
  }, "AURA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 46,
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 500,
    fill: "#20a490"
  }, "Sa\xFAde \xB7 plataforma")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand-logo.1be873c91fcb3582eb873960104c9d59.svg";
export { ForwardRef as ReactComponent };